import data from './data'
import methods from './methods'

export default {
  data,
  methods
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/resources/index.js